import type { DataSource } from '../../lib/data-source'
import type { User } from '../../lib/api/client'
import { dashboardFixture } from '../dashboard/dashboard-fixture'

export type ShellContextData = Pick<
  typeof dashboardFixture,
  'branch' | 'dateLabel' | 'shiftStart' | 'roleLabel'
>

export async function getShellContext(
  source: DataSource,
  user?: User,
  now = new Date(),
): Promise<ShellContextData> {
  if (source === 'api') {
    if (!user) throw new Error('Session required')
    return {
      branch: user.storeId,
      dateLabel: new Intl.DateTimeFormat('th-TH', {
        timeZone: 'Asia/Bangkok',
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      }).format(now),
      shiftStart: '—',
      roleLabel: '—',
    }
  }
  return {
    branch: dashboardFixture.branch,
    dateLabel: dashboardFixture.dateLabel,
    shiftStart: dashboardFixture.shiftStart,
    roleLabel: dashboardFixture.roleLabel,
  }
}
